<template>
  <div class="manage-listings">
    <div
      v-if="listings.length">
      <b-card
        v-for="listing in listings"
        class="mb-4 p-0"
        no-body
        :key="listing.id">
        <b-card-body>
          <b-row class="py-2">
            <b-col
              :cols="12"
              :lg="2"
              :md="2"
              class="mb-2">
              <listing-image
                :src="listing.imageUrl"/>
            </b-col>
            <b-col
              :cols="12"
              :lg="10"
              :md="10">
              <router-link
                class="text-dark"
                target="_blank"
                :to="`/listing/${listing.id}`">
                <h2 class="h5 mb-1">
                  {{ listing.title }}
                  <b-badge
                    v-if="listing.region"
                    variant="info"
                    class="ml-2">
                    {{ listing.region.name }}
                  </b-badge>
                </h2>
              </router-link>
              <div class="mb-2">
                <strong>User:</strong>
                {{ listing.user.firstName }} {{ listing.user.lastName }}
                ({{ listing.user.email }})
                <br>
                <strong>Submitted:</strong>
                {{ listing.createdAt | date }}
              </div>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-footer class="text-right">
          <a
            class="font-weight-bold text-success mr-3"
            href="javascript:void(0);"
            @click="approveListing(listing.id)">
            Approve
          </a>
          <a
            class="font-weight-bold text-danger mr-3"
            href="javascript:void(0);"
            @click="openRejectionModal(listing.id)">
            Reject
          </a>
          <router-link
            class="mr-0"
            :to="`/listing/${listing.id}`"
            target="_blank">
            <span class="font-weight-bold mr-1">
              Preview
            </span>
          </router-link>
          <span class="text-muted mr-2">
            (opens in a new tab)
          </span>
        </b-card-footer>
      </b-card>
    </div>
    <b-card
      v-else>
      <div
        class="p-3 text-center">
        <h2 class="h5">
          No Unapproved Listings
        </h2>
        <p class="mb-0">
          You're all caught up!
        </p>
      </div>
    </b-card>
    <b-modal
      id="rejection-modal"
      ref="rejection-modal"
      title="Reject Listing"
      ok-variant="danger"
      :ok-disabled="rejectionForm.allowResubmit && !rejectionForm.reason"
      cancel-variant="text"
      ok-title="Submit Rejection"
      no-stacking
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      @ok="rejectListing">
      <p>
        When you reject a listing, the seller is notified
        via email. You can choose to permanently reject
        the listing by unchecking the box below.
      </p>
      <b-form>
        <b-form-group>
          <b-form-textarea
            id="textarea"
            v-model="rejectionForm.reason"
            placeholder="Attach a message to the rejection email."
            rows="3"
            max-rows="5">
          </b-form-textarea>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="rejectionForm.allowResubmit">
            Allow the user to resubmit this listing after making requested edits.
          </b-form-checkbox>
        </b-form-group>
        <p
          v-if="!rejectionForm.allowResubmit && !rejectionForm.reason">
          A generic message will be sent to the seller
          indicating that the item is not appropriate
          for ZoopLocal.
        </p>
        <p
          v-else-if="rejectionForm.allowResubmit && !rejectionForm.reason"
          class="text-danger">
          You must leave a note when requesting edits.
        </p>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import ListingImage from '@/components/images/ListingImage.vue'
import date from '@/filters/date.filter'

export default {
  name: 'ReviewListings',
  components: {
    ListingImage,
  },
  filters: {
    date,
  },
  data() {
    return {
      listings: [],
      rejectionForm: {},
    }
  },
  methods: {
    async getUnreviewedListings() {
      try {
        const { data: { listings } } = await this.$http.get('/admin/listings', {
          params: {
            status: 'pending',
          },
        })
        this.listings = listings
      } catch (err) {
        console.log(err)
      }
    },
    resetRejectionForm(id) {
      this.rejectionForm = {
        listingsId: id,
        allowResubmit: true,
        reason: '',
      }
    },
    openRejectionModal(id) {
      this.resetRejectionForm(id)
      this.$bvModal.show('rejection-modal')
    },
    async rejectListing() {
      console.log(JSON.stringify(this.rejectionForm))
      await this.$http.post(`/admin/listing/${this.rejectionForm.listingsId}/reject`, {
        allowResubmit: this.rejectionForm.allowResubmit,
        reason: this.rejectionForm.reason,
      })
      this.resetRejectionForm()
      this.getUnreviewedListings()
    },
    async approveListing(id) {
      const answer = await this.$bvModal.msgBoxConfirm('Are you sure you want to approve this listing?', {
        title: 'Approve Listing',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes, approve this listing',
        cancelTitle: 'No, cancel',
        cancelVariant: 'default',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true,
      })
      if (answer === false) return
      try {
        await this.$http.post(`/admin/listing/${id}/approve`)
      } catch (err) {
        console.log(err)
      }
      this.getUnreviewedListings()
    },
  },
  created() {
    this.getUnreviewedListings()
  },
}
</script>
